import React from 'react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import { VoiceServiceContent } from './components'
import './index.scss'

interface IProps {
  reject?: any;
  showSearch?: () => void;
}

const VoiceModal: React.FC<IProps> = ({ reject, showSearch }) => {
  return (
    <IonModal
      isOpen
      backdropDismiss
      cssClass='voice-modal'
    >
      <IonHeader>
        <i className='iconfont icon-close' onClick={reject} />
      </IonHeader>
      <IonContent>
        <VoiceServiceContent
          type='search'
          onReject={reject}
          onResult={showSearch}
        />
      </IonContent>
    </IonModal>
  )
}

export default VoiceModal
